import {addProst} from "./addProst";
import {redirectToLogin} from "../utils/redirectToLogin";
import {removeProst} from "./removeProst";
import {checkIfAlreadyProsted} from "./checkIfAlreadyProsted";

export function initProst() {
    $(document).on("click", ".prost_link", function (e) {
        e.preventDefault();
        if (shopUserId !== "") {
            var target = $(e.target);
            if (!target.hasClass("clicked")) {
                target.addClass('clicked');
                var container = $(this).closest(".timeline_entry");
                var commentId = "";
                var commentIdArray = "";
                var commentIdNumeric = 0;
                var id = container.attr("id");
                var commentComment = false;
                if ($(this).hasClass('comment')) {
                    commentId = $(this).closest(".display_comment").attr("id");
                    commentIdArray = commentId.split("_");
                    commentIdNumeric = commentIdArray[1];
                    id = 0;
                } else if ($(this).hasClass('comment_comment')) {
                    commentId = $(this).closest(".display_comment_comment").attr("id");
                    commentIdArray = commentId.split("_");
                    commentIdNumeric = commentIdArray[2];
                    id = 0;
                    commentComment = true;
                }
                addProst(id, commentIdNumeric, shopUserId, target, commentComment);
            }
        } else {
            redirectToLogin();
        }
    });
    $(document).on("click", ".un_prost_link", function (e) {
        e.preventDefault();
        var container = $(this).closest(".timeline_entry");
        var id = container.attr("id");
        var commentId = "";
        var commentIdArray = "";
        var commentIdNumeric = 0;
        var commentComment = false;
        if ($(this).hasClass('comment_comment')) {
            commentId = $(this).closest(".display_comment_comment").attr("id");
            commentIdArray = commentId.split("_");
            commentIdNumeric = commentIdArray[2];
            commentComment = true;
        } else if ($(this).hasClass('comment')) {
            commentId = $(this).closest(".display_comment").attr("id");
            commentIdArray = commentId.split("_");
            commentIdNumeric = commentIdArray[1];
        }
        removeProst(id, commentIdNumeric, shopUserId, commentComment);
    });
}